import React from "react";
const WIDTH = 90;
const DEPTH = 40;
const HEIGHT = 30;

export default {
  name: "Rounded-bath",
  prototype: "items",

  info: {
    tag: ["furnishings", "metal"],
    title: "Rounded-bath",
    description: "Rounded-bath",
    image: require("./Rounded-bath.svg"),
    svgIcon: require("./Rounded-bath.svg"),
  },
  properties: {
    scaleX: {
      label: "Width",
      type: "slider",
      min: 50,
      max: 500,
      defaultValue: 100,
    },
    scaleY: {
      label: "Depth",
      type: "slider",
      min: 50,
      max: 500,
      defaultValue: 100,
    },
  },

  render2D: function (element, layer, scene) {
    let angle = element.rotation + 90;

    return {
      element: (
        <g transform={`translate(-47, 55) scale(1, -1)`}>
          <defs>
            <style>{`.cls-1{fill:#fff;}`}</style>
          </defs>
          <g id={`${element.type}-${element.id}`} data-name="corner shower">
            <path
              d="M22.72,49.73q0-13.93,0-27.87A19.19,19.19,0,0,1,23.56,16a19.8,19.8,0,0,1,5.51-8.59A27.47,27.47,0,0,1,45.37.2,29.85,29.85,0,0,1,63,3.43c5.43,2.9,9.5,7.06,11.21,13.13a19.29,19.29,0,0,1,.68,5q.08,28.13,0,56.27a19,19,0,0,1-6.58,14.36,26.84,26.84,0,0,1-12.44,6.4,1.25,1.25,0,0,0-.71.53,1.6,1.6,0,0,1-1.79.83c-1.47-.21-3-.34-4.41-.55-1.73-.24-3.34.39-5,.56a1.71,1.71,0,0,1-1.91-.91,1.31,1.31,0,0,0-.69-.54,27.27,27.27,0,0,1-8.7-3.71c-4.55-3-7.94-6.89-9.32-12.26a20.65,20.65,0,0,1-.6-5C22.69,68.27,22.72,59,22.72,49.73ZM50.29,94.88a9,9,0,0,0,1.4,0,52.25,52.25,0,0,0,5.73-1.29,17.84,17.84,0,0,0,9.76-7.69A18.9,18.9,0,0,0,69.9,75.63V24.45a29.28,29.28,0,0,0-.15-3.24A17.58,17.58,0,0,0,60.84,7.39a22.49,22.49,0,0,0-11.56-3A23.65,23.65,0,0,0,37,7.41a18.12,18.12,0,0,0-8.14,9.38,19.54,19.54,0,0,0-1.19,7.15q0,20.87,0,41.74c0,3.88-.06,7.77.08,11.65a16.76,16.76,0,0,0,4.76,11.13A20.63,20.63,0,0,0,45,94.71c.65.09,1.3.14,1.91.21a.92.92,0,0,0,.09-.23c0-1,0-2,0-3,0-1.21.57-1.87,1.59-1.88s1.62.59,1.65,1.81S50.29,93.75,50.29,94.88Zm.15.92-.06.27a7.3,7.3,0,0,0,1.12.27c.73.06,1.48,0,2.19.09a2.14,2.14,0,0,1,1.3.7.89.89,0,0,0,1.12.35,25.87,25.87,0,0,0,11.74-6.33,17.91,17.91,0,0,0,5.88-13.38q0-28.06,0-56.13a18.9,18.9,0,0,0-.63-4.73c-1.29-5-4.52-8.64-8.75-11.44A26.33,26.33,0,0,0,52.48,1.3C44.83.48,37.73,2,31.55,6.73a18.55,18.55,0,0,0-7.67,15.36c0,18.44,0,36.88,0,55.33a21.23,21.23,0,0,0,.15,2.87,18.38,18.38,0,0,0,5.84,11,26,26,0,0,0,11.49,6.19.69.69,0,0,0,.85-.3,2,2,0,0,1,1-.63c.81-.14,1.65-.12,2.48-.2.45,0,.9-.16,1.46-.27-.2-.23-.22-.29-.26-.29s-.38-.07-.58-.11a60.42,60.42,0,0,1-6.17-1.34A19.28,19.28,0,0,1,30.93,88a19.06,19.06,0,0,1-4.18-12.45q0-25.86,0-51.71a20.86,20.86,0,0,1,.43-4.54c1.6-7.13,6.09-11.78,12.86-14.19a26.24,26.24,0,0,1,17.72,0A19,19,0,0,1,67.9,13a19.5,19.5,0,0,1,2.88,10.67q0,25.56,0,51.12a30.07,30.07,0,0,1-.3,4.55,18.1,18.1,0,0,1-7.74,12.4,21.42,21.42,0,0,1-10,3.73ZM50.26,97a5.77,5.77,0,0,1-.41-1.3c-.08-1.37-.11-2.75-.15-4.12,0-.89-.36-1.28-1.07-1.26s-1,.4-1,1.27c0,1.28,0,2.56,0,3.83,0,.66.05,1.28-.65,1.34l.24,2.07c.36,0,.84,0,1.33-.06s1,0,1.34,0Zm-5.78,1.26a1.14,1.14,0,0,0-1-1.21,1.1,1.1,0,0,0-1,1.22,1.14,1.14,0,0,0,1,1.18A1.16,1.16,0,0,0,44.48,98.26Zm9.35-1.21a1.13,1.13,0,0,0-1,1.2,1.17,1.17,0,0,0,1,1.2,1.21,1.21,0,0,0,.06-2.4Zm-1-.21a1.92,1.92,0,0,0-2,.68,1.29,1.29,0,0,0,0,1.08c.34.61,1,.7,1.71.7A2,2,0,0,1,52.8,96.84Zm-8,2.5c.82,0,1.48-.19,1.76-.88a1.28,1.28,0,0,0-.08-1.07,1.65,1.65,0,0,0-1.88-.51A2.12,2.12,0,0,1,44.75,99.34Z"
              transform="translate(-22.71 0)"
            />
            <path
              class="cls-1"
              d="M50.29,94.88c0-1.13,0-2.2,0-3.28s-.58-1.81-1.65-1.81-1.58.67-1.59,1.88c0,1,0,2,0,3a.92.92,0,0,1-.09.23c-.61-.07-1.26-.12-1.91-.21a20.63,20.63,0,0,1-12.55-6.25,16.76,16.76,0,0,1-4.76-11.13c-.14-3.88-.08-7.77-.08-11.65q0-20.88,0-41.74a19.54,19.54,0,0,1,1.19-7.15A18.12,18.12,0,0,1,37,7.41a23.65,23.65,0,0,1,12.32-3,22.49,22.49,0,0,1,11.56,3,17.58,17.58,0,0,1,8.91,13.82,29.28,29.28,0,0,1,.15,3.24V75.63a18.9,18.9,0,0,1-2.72,10.26,17.84,17.84,0,0,1-9.76,7.69,52.25,52.25,0,0,1-5.73,1.29A9,9,0,0,1,50.29,94.88Zm-1.7-12.57a2.16,2.16,0,1,0,0,4.3,2.16,2.16,0,1,0,0-4.3Z"
              transform="translate(-22.71 0)"
            />
            <path
              class="cls-1"
              d="M50.44,95.8l2.31-.29a21.42,21.42,0,0,0,10-3.73,18.1,18.1,0,0,0,7.74-12.4,30.07,30.07,0,0,0,.3-4.55q0-25.56,0-51.12A19.5,19.5,0,0,0,67.9,13a19,19,0,0,0-10.12-8,26.24,26.24,0,0,0-17.72,0C33.29,7.52,28.8,12.17,27.2,19.3a20.86,20.86,0,0,0-.43,4.54q0,25.85,0,51.71A19.06,19.06,0,0,0,30.93,88a19.28,19.28,0,0,0,9.25,6.31,60.42,60.42,0,0,0,6.17,1.34c.2,0,.39.06.58.11s.06.06.26.29c-.56.11-1,.22-1.46.27-.83.08-1.67.06-2.48.2a2,2,0,0,0-1,.63.69.69,0,0,1-.85.3,26,26,0,0,1-11.49-6.19,18.38,18.38,0,0,1-5.84-11,21.23,21.23,0,0,1-.15-2.87c0-18.45,0-36.89,0-55.33A18.55,18.55,0,0,1,31.55,6.73C37.73,2,44.83.48,52.48,1.3A26.33,26.33,0,0,1,64.33,5.47c4.23,2.8,7.46,6.41,8.75,11.44a18.9,18.9,0,0,1,.63,4.73q.06,28.07,0,56.13a17.91,17.91,0,0,1-5.88,13.38,25.87,25.87,0,0,1-11.74,6.33A.89.89,0,0,1,55,97.13a2.14,2.14,0,0,0-1.3-.7c-.71-.13-1.46,0-2.19-.09a7.3,7.3,0,0,1-1.12-.27Z"
              transform="translate(-22.71 0)"
            />
            <path
              class="cls-1"
              d="M50.26,97l-.35,1.76c-.33,0-.84,0-1.34,0s-1,0-1.33.06L47,96.76c.7-.06.66-.68.65-1.34,0-1.27,0-2.55,0-3.83,0-.87.32-1.26,1-1.27s1,.37,1.07,1.26c0,1.37.07,2.75.15,4.12A5.77,5.77,0,0,0,50.26,97Z"
              transform="translate(-22.71 0)"
            />
            <path
              class="cls-1"
              d="M44.48,98.26a1.16,1.16,0,0,1-1,1.19,1.14,1.14,0,0,1-1-1.18,1.1,1.1,0,0,1,1-1.22A1.14,1.14,0,0,1,44.48,98.26Z"
              transform="translate(-22.71 0)"
            />
            <path
              class="cls-1"
              d="M53.83,97.05a1.21,1.21,0,0,1-.06,2.4,1.17,1.17,0,0,1-1-1.2A1.13,1.13,0,0,1,53.83,97.05Z"
              transform="translate(-22.71 0)"
            />
            <path
              class="cls-1"
              d="M52.8,96.84a2,2,0,0,0-.29,2.46c-.72,0-1.37-.09-1.71-.7a1.29,1.29,0,0,1,0-1.08A1.92,1.92,0,0,1,52.8,96.84Z"
              transform="translate(-22.71 0)"
            />
            <path
              class="cls-1"
              d="M44.75,99.34a2.12,2.12,0,0,0-.2-2.46,1.65,1.65,0,0,1,1.88.51,1.28,1.28,0,0,1,.08,1.07C46.23,99.15,45.57,99.3,44.75,99.34Z"
              transform="translate(-22.71 0)"
            />
            <path
              d="M48.59,82.31a2.16,2.16,0,1,1,0,4.3,2.16,2.16,0,1,1,0-4.3Zm0,.55a1.62,1.62,0,1,0-.05,3.22,1.62,1.62,0,1,0,.05-3.22Z"
              transform="translate(-22.71 0)"
            />
            <path
              class="cls-1"
              d="M48.63,82.86a1.62,1.62,0,1,1-.05,3.22,1.62,1.62,0,1,1,.05-3.22Z"
              transform="translate(-22.71 0)"
            />
          </g>
        </g>
      ),
      transform: {
        width: -WIDTH / 2,
        depth: -DEPTH / 2,
      },
    };
  },

  render3D: function (element, layer, scene) {},
};
